<template>
  <app-board :header="false" class="p-3 mb-3">
    <h5 class="border-bottom mb-3">Server Allow IP </h5>
    <el-row class="mb-3">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :field_span="16"
            :label_span="24"
            :options="serversList"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="serverUpdated"
            field_mark="required"
            label="Server"
            name="server_id"
            rules="required"></dg-select-field>
      </el-col>

      <!--<el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-button class="mr-2 mt-4" :translate="false" text="Test" type="primary" icon="el-icon-magic-stick" fieldSize="mini" :click="listAllowedServerIPS"></dg-button>
      </el-col>-->
    </el-row>


    <div v-if="serverId">
      <h5 class="border-bottom mb-3">Allow New IP</h5>
      <el-row class="mb-3 ml-3">
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
          <dg-text-field
              :control="control"
              :field_span="19"
              :label_span="24"
              :translateLabel="false"
              field_mark="required"
              label="IP"
              name="newIP"
              placeholder="162.134.32.11"
              rules="required"></dg-text-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
          <dg-text-field
              :control="control"
              :field_span="19"
              :label_span="24"
              :translateLabel="false"
              field_mark="required"
              label="Description"
              name="newIPDescription"
              placeholder="Jikatel HQ IP"
              rules="required"></dg-text-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6" class="pt-2">
          <dg-button :click="allowIP" :translate="false" class="mr-2 mt-4" fieldSize="mini" icon="el-icon-check"
                     text="Allow IP" type="primary"></dg-button>
        </el-col>
      </el-row>
    </div>

    <div v-if="serverId">
      <h5 class="border-bottom mb-3">Server IPs</h5>
      <div :key="key" v-for="(line, key) in allowedIPS">
        <el-row class="mb-3 ml-3">
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6" class="pt-4">
            <span>{{ viewOnlyIp(line) }}</span>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-text-field
                :control="control"
                :field_span="19"
                :label_span="24"
                :name="viewOnlyIp(line) + '_desc'"
                :translateLabel="false"
                field_mark="required"
                label="Description"
                :readonly="true"
                :defaultValue="viewIPDescription(viewOnlyIp(line))"
                placeholder="Fusion CLI Server"
                rules="required"></dg-text-field>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6" class="pt-2">
            <el-button @click="denyIP(key)" class="mr-2 mt-4" size="mini" icon="el-icon-close" type="danger">
              Deny IP
            </el-button>
          </el-col>
        </el-row>
      </div>
    </div>


  </app-board>
</template>

<script>
import module from './../index.js'
import {mapState, mapActions} from 'vuex'
import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';

export default {
  mixins: [fieldController],
  props: {
    editMode: {
      required: false,
      type: Boolean,
      default: true
    },
  },
  beforeMount() {
    this.getServersDropDownList({valueKey: 'id'}).then((r) => {
      this.serversList = r
    })
  },
  methods: {
    ...mapActions('network-server-api', {
      listAllowedServerIPSCommand: 'listAllowedServerIPSCommand',
      allowIPCommand: 'allowIPCommand',
      denyIPCommand: 'denyIPCommand',
    }),
    ...mapActions('network-server-api', {getServersDropDownList: 'getDropDownList'}),
    viewIPDescription (ip) {
      return this.ipsDescription[ip]
    },
    prepareServerJsonData() {
      let json = {}
      let allowedIPS = this.allowedIPS
      for (let d in allowedIPS) {
        let ip = this.viewOnlyIp(allowedIPS[d]);
        json[ip] = this.dataModel[ip + '_desc'] || ''
      }
      return json
    },
    allowIP() {
      let serverAllowedIPsJson = this.prepareServerJsonData()

      serverAllowedIPsJson[this.dataModel.newIP] = this.dataModel.newIPDescription

      let data = {
        ip: this.dataModel.newIP,
        json: serverAllowedIPsJson,
        server_id: this.serverId
      }
      this.allowIPCommand({data}).then((r) => {
        this.viewAllowedIPResults(r)
      })
    },
    denyIP(rowIndex) {
      let ipToDeny = this.viewOnlyIp(this.allowedIPS[rowIndex])
      this.allowedIPS.splice(rowIndex, 1);
      let serverAllowedIPsJson = this.prepareServerJsonData()

      serverAllowedIPsJson[this.dataModel.newIP] = this.dataModel.newIPDescription

      let data = {
        ip: ipToDeny,
        json: serverAllowedIPsJson,
        server_id: this.serverId
      }
      this.denyIPCommand({data}).then((r) => {
        this.viewAllowedIPResults(r)
      })
    },
    serverUpdated() {
      this.listAllowedServerIPS()
    },
    viewAllowedIPResults(r) {
      this.commandResults = JSON.parse(r.data.ips)
      this.ipsDescription = JSON.parse(r.data.descriptions.json)
      let startIndex = this.commandResults.indexOf('') + 3
      this.allowedIPS = this.commandResults.slice(startIndex, -1)
    },
    listAllowedServerIPS() {
      this.serverId = this.dataModel.server_id;
      let serverId = this.serverId

      if (!serverId) {
        this.fields['server_id'].field.validateMessage = 'this field is required'
        return
      }

      let data = {
        server_id: serverId
      }



      this.listAllowedServerIPSCommand({data}).then((r) => {
        this.viewAllowedIPResults(r)
      })
    },
    viewOnlyIp(allowedIP) {
      return allowedIP.split('ALLOW')[1].trim()
    }
  },
  data() {
    return {
      dataModel: {
        serverId: false
      },
      serverId: false,
      control: this,
      serversList: [],
      commandResults: [],
      allowedIPS: [],
      ipsDescription: {}
    }
  }
}
</script>
